import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Sparkles, X } from "lucide-react";
import CopilotPanel from "@/components/copilot/CopilotPanel";

/**
 * Sprint 25 — Floating Copilot button visible when the tenant is signed in.
 * Opens a right-side sheet with the chat panel.
 */
export default function CopilotFab() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user || user === false) return null;
  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        className="fixed z-40 bottom-5 right-5 h-14 w-14 rounded-full shadow-elev-3 gap-1 flex flex-col items-center justify-center"
        data-testid="copilot-fab"
      >
        <Sparkles className="w-5 h-5" />
        <span className="text-[9px] leading-none">AI</span>
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:w-[440px] p-0 flex flex-col">
          <SheetHeader className="px-4 py-3 border-b flex-row items-center justify-between">
            <SheetTitle className="text-base flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-primary" /> Copilot
            </SheetTitle>
          </SheetHeader>
          <div className="flex-1 min-h-0">
            <CopilotPanel compact />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
